import { observer } from "mobx-react";
import React from "react";
import { Card, Text, Button, Stack, Group, Badge } from "@mantine/core";
import { BobsWorkspace } from "../../stores/BobsWorkspace";
import { Bob } from "../../stores/Bob";

const SelectBob = observer(
  ({ bobsWorkspace }: { bobsWorkspace: BobsWorkspace }) => {
    const selectedBob = bobsWorkspace.selectedBob;

    const selectBobHereAndRemote = (bob: Bob, uuidOfBobToSelect: string) => {
      selectedBob.sendDataAndDirectiveToRails("select-bob", {
        uuidOfBobToSelect: uuidOfBobToSelect,
      });
      bobsWorkspace.selectBob(bob);
      selectedBob.setOpenModal(null);
    };

    return (
      <Stack>
        {bobsWorkspace.bobs
          .filter((bob) => bob !== selectedBob)
          .map((bob) => {
            const balanceSats = bob.safeBalanceInSatoshis;
            const balanceFiat = bob.formatFiat(balanceSats);

            return (
              <Card
                key={bob.uuid}
                shadow="sm"
                padding="lg"
                radius="md"
                withBorder
              >
                <Stack gap="xs">
                  <Group justify="space-between">
                    <Text fw={600}>{bob.lightningAddress}</Text>
                    <Badge color="blue">{bob.currencyCode.toUpperCase()}</Badge>
                  </Group>

                  <Group gap="xs">
                    <Text size="sm" c="dimmed">
                      Balance:
                    </Text>
                    <Text>{balanceSats.toLocaleString()} sats</Text>
                    {balanceSats > 0 && <Text c="dimmed">({balanceFiat})</Text>}
                  </Group>

                  <Button
                    mt="sm"
                    color="blue"
                    fullWidth
                    onClick={() => selectBobHereAndRemote(bob, bob.uuid)}
                  >
                    Switch To This Vault
                  </Button>
                </Stack>
              </Card>
            );
          })}
      </Stack>
    );
  }
);

export default SelectBob;
